import AddressAppResource from "./AddressAppResource";
import AgentContactAppResource from "./AgentContactAppResource";
import AgentContactNoteAppResource from "./AgentContactNoteAppResource";
import BusinessCategoryAppResource from "./BusinessCategoryAppResource";
import BusinessLicenseAppResource from "./BusinessLicenseAppResource";
import BusinessProfileAppResource from "./BusinessProfileAppResource";
import BusinessScheduleAppResource from "./BusinessScheduleAppResource";
import BusinessTypeAppResource from "./BusinessTypeAppResource";
import CalendarAppResource from "./CalendarAppResource";
import CalendarCategoryAppResource from "./CalendarCategoryAppResource";
import CalendarEventAppResource from "./CalendarEventAppResource";
import CalendarEventAttendeeAppResource from "./CalendarEventAttendeeAppResource";
import CalendarEventAttendeeReminderAppResource from "./CalendarEventAttendeeReminderAppResource";
import CalendarEventCategoryAppResource from "./CalendarEventCategoryAppResource";
import CalendarEventStatusAppResource from "./CalendarEventStatusAppResource";
import ChannelAppResource from "./ChannelAppResource";
import ChannelMemberAppResource from "./ChannelMemberAppResource";
import ContactAppResource from "./ContactAppResource";
import DocumentTagAppResource from "./DocumentTagAppResource";
import EmailAppResource from "./EmailAppResource";
import FileAppResource from "./FileAppResource";
import FolderAppResource from "./FolderAppResource";
import FileTagAppResource from "./FileTagAppResource";
import IndustryAssociationAppResource from "./IndustryAssociationAppResource";
import InquiryAppResource from "./InquiryAppResource";
import InquiryPropertyStatusAppResource from "./InquiryPropertyStatusAppResource";
import InquiryPropertySubtypeAppResource from "./InquiryPropertySubtypeAppResource";
import InquiryPropertyTypeAppResource from "./InquiryPropertyTypeAppResource";
import KnowledgeAssetAppResource from "./KnowledgeAssetAppResource";
import KnowledgeAssetArticleAppResource from "./KnowledgeAssetArticleAppResource";
import KnowledgeAssetCategoryAppResource from "./KnowledgeAssetCategoryAppResource";
import KnowledgeAssetTagAppResource from "./KnowledgeAssetTagAppResource";
import KnowledgeAssetVideoAppResource from "./KnowledgeAssetVideoAppResource";
import KnowledgeBaseAppResource from "./KnowledgeBaseAppResource";
import LanguageAppResource from "./LanguageAppResource";
import LeadAppResource from "./LeadAppResource";
import LeadDispositionAppResource from "./LeadDispositionAppResource";
import LeadQualificationDispositionQuestionAppResource from "./LeadQualificationDispositionQuestionAppResource";
import LeadQualificationQuestionAppResource from "./LeadQualificationQuestionAppResource";
import LeadSourceAppResource from "./LeadSourceAppResource";
import LeadTypeAppResource from "./LeadTypeAppResource";
import LuCalendarEventAttendeeStatusAppResource from "./LuCalendarEventAttendeeStatusAppResource";
import LuWorkspaceMembershipTypeAppResource from "./LuWorkspaceMembershipTypeAppResource";
import LuOrganizationReportingRoleAppResource from "./LuOrganizationReportingRoleAppResource";
import MarketAppResource from "./MarketAppResource";
import MLSAppResource from "./MLSAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";
import OrganizationRoleAppResource from "./OrganizationRoleAppResource";
import PhoneAppResource from "./PhoneAppResource";
import PropertyAppResource from "./PropertyAppResource";
import PropertyInstanceAppResource from "./PropertyInstanceAppResource";
import RoleAppResource from "./RoleAppResource";
import ServiceTicketAppResource from "./ServiceTicketAppResource";
import StageAppResource from "./StageAppResource";
import StageRoleAppResource from "./StageRoleAppResource";
import StageTypeAppResource from "./StageTypeAppResource";
import StageWorkspaceMemberAppResource from "./StageWorkspaceMemberAppResource";
import TaskAppResource from "./TaskAppResource";
import TaskAssigneeAppResource from "./TaskAssigneeAppResource";
import TaskAssigneeReminderAppResource from "./TaskAssigneeReminderAppResource";
import TaskCategoryAppResource from "./TaskCategoryAppResource";
import TaskPriorityAppResource from "./TaskPriorityAppResource";
import TaskRoleAppResource from "./TaskRoleAppResource";
import TaskStatusAppResource from "./TaskStatusAppResource";
import UserAppResource from "./UserAppResource";
import UserInvitationAppResource from "./UserInvitationAppResource";
import WildAppResource from "./WildAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import WorkspaceOrganizationMemberAppResource from "./WorkspaceOrganizationMemberAppResource";
import WorkspaceStageTypeAppResource from "./WorkspaceStageTypeAppResource";
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import WorkspaceRoleAppResource from "./WorkspaceRoleAppResource";
import MessageAppResource from "./MessageAppResource";
import MessageChannelMemberReadAppResource from "./MessageChannelMemberReadAppResource";
import MessageMentionAppResource from "./MessageMentionAppResource";
import TaskReminderAppResource from "./TaskReminderAppResource";
import CalendarEventReminderAppResource from "./CalendarEventReminderAppResource";
import PlaybookAppResource from "./PlaybookAppResource";
import LuOrganizationOccupationAppResource from "./LuOrganizationOccupationAppResource";
import ResourceAppResource from "./ResourceAppResource";
import ResourceType1AppResource from "./ResourceType1AppResource";
import ResourceType2AppResource from "./ResourceType2AppResource";
import ResourceType3AppResource from "./ResourceType3AppResource";
import ResourceStageTypeAppResource from "./ResourceStageTypeAppResource";
import ResourceWorkspaceTypeAppResource from "./ResourceWorkspaceTypeAppResource";
import TaskListAppResource from "./TaskListAppResource";
import TimelineAppResource from "./TimelineAppResource";
import PublicOrganizationAppResource from "./PublicOrganizationAppResource";
import LuDeclineInvitationReasonAppResource from "./LuDeclineInvitationReasonAppResource";
import BillboardAppResource from "./BillboardAppResource";
import ProjectBillboardAppResource from "./ProjectBillboardAppResource";
import AuthCodeAppResource from "./OAuth/AuthCodeAppResource";
import ClientAppResource from "./OAuth/ClientAppResource";
import PersonalAccessClientAppResource from "./OAuth/PersonalAccessClientAppResource";
import RefreshTokenAppResource from "./OAuth/RefreshTokenAppResource";
import TokenAppResource from "./OAuth/TokenAppResource";
import QuestionAppResource from "./QuestionAppResource";
import OptionAppResource from "./OptionAppResource";
import AnswerAppResource from "./AnswerAppResource";
import LuProcessInputTypeAppResource from './LuProcessInputTypeAppResource'
import LuProcessOutputTypeAppResource from './LuProcessOutputTypeAppResource'
import LuProcessTypeAppResource from './LuProcessTypeAppResource'
import ProcessAppResource from './ProcessAppResource'
import ProcessInputAppResource from './ProcessInputAppResource'
import ProcessInputCategoryAppResource from './ProcessInputCategoryAppResource'
import ProcessInstanceAppResource from './ProcessInstanceAppResource'
import ProcessInstanceInputAppResource from './ProcessInstanceInputAppResource'
import ProcessOutputAppResource from './ProcessOutputAppResource'
import CityAppResource from './CityAppResource';
import MlsMarketAppResource from './MlsMarketAppResource';
import CityMlsMarketAppResource from './CityMlsMarketAppResource';
import PropertySearchFilterAppResource from "./PropertySearchFilterAppResource";
import FileDownloadTokenAppResource from "./FileDownloadTokenAppResource";
import ZipInfoAppResource from "./ZipInfoAppResource";
import ReferralPartnerTypeAppResource from './ReferralPartnerTypeAppResource';
import BusinessProfileServiceAppResource from './BusinessProfileServiceAppResource';
import ReferralPartnerAppResource from './ReferralPartnerAppResource';
import UserProfileAppResource from "./UserProfileAppResource";
import RecommendedBusinessAppResource from "./RecommendedBusinessAppResource";
import ActivityAppResource from "./ActivityAppResource";
import PushSubscriptionAppResource from './PushSubscriptionAppResource';
import ActivityHistorySavedViewAppResource from "./ActivityHistorySavedViewAppResource";
import FormAppResource from "./FormAppResource";
import FormAuthorAppResource from "./FormAuthorAppResource";
import FormsetAppResource from "./FormsetAppResource";
import FormsetStartPageAppResource from "./FormsetStartPageAppResource";
import FormsetSuccessPageAppResource from "./FormsetSuccessPageAppResource";
import LuCountryAppResource from "./LuCountryAppResource";
import LuStateAppResource from "./LuStateAppResource";
import LuESignatureMethodAppResource from "./LuESignatureMethodAppResource";
import LuFormAuthorTypeAppResource from "./LuFormAuthorTypeAppResource";
import LuFormCategoryAppResource from "./LuFormCategoryAppResource";
import LuFormLicenceStatusAppResource from "./LuFormLicenceStatusAppResource";
import LandingPageAppResource from "./LandingPageAppResource";
import LandingPageBuySectionAppResource from "./LandingPageBuySectionAppResource";
import LandingPageFinanceSectionAppResource from "./LandingPageFinanceSectionAppResource";
import LandingPageHomeSectionAppResource from "./LandingPageHomeSectionAppResource";
import LandingPageLearnSectionAppResource from "./LandingPageLearnSectionAppResource";
import LandingPageHomeLoanOfficerAppResource from "./LandingPageHomeLoanOfficerAppResource";
import LandingPageLinkAppResource from "./LandingPageLinkAppResource";
import LandingPagePhoneAppResource from "./LandingPagePhoneAppResource";
import LandingPageSocialLinkAppResource from "./LandingPageSocialLinkAppResource";
import LandingPageSellSectionAppResource from "./LandingPageSellSectionAppResource";
import LandingPageTradeSectionAppResource from "./LandingPageTradeSectionAppResource";
import LandingPageTypeSectionTypeAppResource from "./LandingPageTypeSectionTypeAppResource";
import LuLandingPageSectionTypeAppResource from "./LuLandingPageSectionTypeAppResource";
import LuLandingPageTypeAppResource from "./LuLandingPageTypeAppResource";
import LuLandingPageCategoryAppResource from "./LuLandingPageCategoryAppResource";
import LandingPageSettingsAppResource from "./LandingPageSettingsAppResource";
import LandingPageActionAppResource from "./LandingPageActionAppResource";
import SearchAlertSubscriberAppResource from "./SearchAlertSubscriberAppResource";
import KloudlessAccountAppResource from "./KloudlessAccountAppResource";
import KloudlessServiceAppResource from "./KloudlessServiceAppResource";
import KloudlessAccountCalendarPermissionAppResource from "./KloudlessAccountCalendarPermissionAppResource";
import LuNotificationTypeAppResource from "./LuNotificationTypeAppResource";
import UserNotificationAppResource from "./UserNotificationAppResource";
import WorkspaceMemberNotificationAppResource from "./WorkspaceMemberNotificationAppResource";
import LandingPageHomeBabyOrAdoptionAppResource from "./LandingPageHomeBabyOrAdoptionAppResource";
import LuWorkspacePipelineStatusAppResource from "./LuWorkspacePipelineStatusAppResource";
import LandingPageViewAppResource from "./LandingPageViewAppResource";
import LuLandingPageGalleryTypeAppResource from "./LuLandingPageGalleryTypeAppResource";
import LandingPageGalleryImageAppResource from "./LandingPageGalleryImageAppResource";
import LandingPageEmailBlastAppResource from "./LandingPageEmailBlastAppResource";
import ProfessionalLicenseAppResource from "./ProfessionalLicenseAppResource";
import MlsMembershipAppResource from "./MlsMembershipAppResource";
import FormsetAdvertisementAppResource from "./FormsetAdvertisementAppResource";
import JotFormResourceAnswerAppResource from "./JotFormResourceAnswerAppResource";
import JotFormResourceSessionAppResource from "./JotFormResourceSessionAppResource";
import ProjectMemberResourceAppResource from "./ProjectMemberResourceAppResource";
import LandingPageHomeTopicOfInterestAppResource from "./LandingPageHomeTopicOfInterestAppResource";
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";
import ServiceProviderJotformRequestAppResource from "./ServiceProviderJotformRequestAppResource";
import ServiceProviderImportAppResource from "./ServiceProviderImportAppResource";
import LandingPageEventAppResource from "./LandingPageEventAppResource";
import ProjectTypeRoleAppResource from "./ProjectTypeRoleAppResource";
import LuAgentContactTypeAppResource from "./LuAgentContactTypeAppResource";

import PropertyValuationAppResource from "./PropertyValuationAppResource";
import PropertyMortgageAppResource from "./PropertyMortgageAppResource";
import PropertyContactAppResource from "./PropertyContactAppResource";
import PropertyContactNoteAppResource from "./PropertyContactNoteAppResource";
import LuPropertyContactTypeAppResource from "./LuPropertyContactTypeAppResource";
import HomeownersInsuranceAppResource from "./HomeownersInsuranceAppResource";
import HomeValuationRequestAppResource from "./HomeValuationRequestAppResource";
import MortgageRateAppResource from "./MortgageRateAppResource";
import LuListingStatusAppResource from "./LuListingStatusAppResource";
import HomeJunctionListingStatusAppResource from "./HomeJunctionListingStatusAppResource";
import AssessorRecordAppResource from "./AssessorRecordAppResource";
import FirstAmericanLogAppResource from "./FirstAmericanLogAppResource";
import LuFinTypeAppResource from "./LuFinTypeAppResource";
import LuFipsAppResource from "./LuFipsAppResource";
import LuLoanTypeAppResource from "./LuLoanTypeAppResource";
import ModelRecordAppResouce from "./ModelRecordAppResouce";
import TaskRecurrenceAppResource from "./TaskRecurrenceAppResource";
import LuHomeTypeAppResource from "./LuHomeTypeAppResource";
import HomeJunctionHomeTypeAppResource from "./HomeJunctionHomeTypeAppResource";
import NylasAccountAppResource from "./NylasAccountAppResource";
import EmailCampaignAppResource from "./EmailCampaignAppResource";
import EmailCampaignMessageAppResource from "./EmailCampaignMessageAppResource";
import EmailCampaignMessageSentAppResource from "./EmailCampaignMessageSentAppResource";
import EmailCampaignUserAppResource from "./EmailCampaignUserAppResource";
import UserAccountConfirmationAppResource from "./UserAccountConfirmationAppResource";
import ExternalListingAppResource from "./ExternalListingAppResource";
import HubExternalListingAppResource from "./HubExternalListingAppResource";
import MortgageBalanceAppResource from "./MortgageBalanceAppResource";
import LoanOfficerActionProgressAppResource from "./LoanOfficerActionProgressAppResource";
import WorkspaceLifeEventAppResource from "./WorkspaceLifeEventAppResource";
import ExternalUserAppResource from "./ExternalUserAppResource";
import WorkspacePropertyValuationAppResource from "./WorkspacePropertyValuationAppResource";
import GlobalUnsubscribeEmailAppResource from "./GlobalUnsubscribeEmailAppResource";
import UnsubscribedEmailUserAppResource from "./UnsubscribedEmailUserAppResource";
import OrganizationAgentImportAppResource from "./OrganizationAgentImportAppResource";
import OrganizationAgentImportLogAppResource from "./OrganizationAgentImportLogAppResource";
import PendingHubDetailsAppResource from "./PendingHubDetailsAppResource";
import HubInvitationSettingsAppResource from "./HubInvitationSettingsAppResource";
import SendGridMetricsAppResource from "./SendGridMetricsAppResource";
import UserInvitationEventAppResource from "./UserInvitationEventAppResource";
import OrganizationSendgridTemplateAppResource from "./OrganizationSendgridTemplateAppResource";
import PartnerMlsMappingAppResource from "./PartnerMlsMappingAppResource";
import ReferProLinkAppResource from "./ReferProLinkAppResource";
import OrganizationHubImportAppResource from "./OrganizationHubImportAppResource";
import MilestonesSendgridTemplateAppResource from './MilestonesSendgridTemplateAppResource';
import UnsubscribeEmailAppResource from "./UnsubscribeEmailAppResource";
import ServiceAreaAppResource from "./ServiceAreaAppResource";

//attom
import S3RecorderImportAppResource from "./S3RecorderImportAppResource";
import S3AvmImportAppResource from "./S3AvmImportAppResource";


//Moxi
import OrganizationMoxiCompanyAppResource from "./OrganizationMoxiCompanyAppResource";
import OrganizationMoxiOfficeAppResource from "./OrganizationMoxiOfficeAppResource";
import TransactionAppResource from "./TransactionAppResource";
import TransactionWorkspaceAppResource from "./TransactionWorkspaceAppResource";
import LuIntegrationTypeAppResource from "./LuIntegrationTypeAppResource";
import LuTransactionTypeAppResource from "./LuTransactionTypeAppResource";
import IntegrationStageTransactionStatusAppResource from "./IntegrationStageTransactionStatusAppResource";
import LuTransactionStatusAppResource from "./LuTransactionStatusAppResource";

import OrganizationIntegrationAppResource from "./OrganizationIntegrationAppResource";
import TransactionImportFilterAppResource from "./TransactionImportFilterAppResource";
import IntegrationListingStatusAppResource from "./IntegrationListingStatusAppResource";
import LandingPageHubPreviewAppResource from "./LandingPageHubPreviewAppResource";
import MoveHubAppResource from "./MoveHubAppResource";

import ServiceProviderIndustryAppResource from "./ServiceProviderIndustryAppResource";
import ServiceProviderProjectTypeAppResource from "./ServiceProviderProjectTypeAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import ServiceProviderCallToActionAppResource from "./ServiceProviderCallToActionAppResource";
import ServiceProviderLocationAppResource from "./ServiceProviderLocationAppResource";
import ServiceProviderMessageAppResource from "./ServiceProviderMessageAppResource";
import ServiceProviderFavoriteAppResource from "./ServiceProviderFavoriteAppResource";
import ServiceProviderUserProfessionalAppResource from "./ServiceProviderUserProfessionalAppResource";
import ServiceProviderRecommendationAppResource from "./ServiceProviderRecommendationAppResource";
import ServiceProviderRecommendationTypeAppResource from "./ServiceProviderRecommendationTypeAppResource";
import ServiceProviderOrganizationListSettingAppResource from "./ServiceProviderOrganizationListSettingAppResource";
import ServiceProviderContactLicenseTypeAppResource from "./ServiceProviderContactLicenseTypeAppResource";
import OrganizationBrandingAppResource from "./OrganizationBrandingAppResource";
import OrganizationPlatformBabAppResource from "./OrganizationPlatformBabAppResource";
import ServiceProviderReferralTypeAppResource from "./ServiceProviderReferralTypeAppResource";
import ServiceProviderReferralLogAppResource from "./ServiceProviderReferralLogAppResource";
import ServiceProviderCallToActionTypeAppResource from "./ServiceProviderCallToActionTypeAppResource";
import ServiceProviderEmergencyCardAppResource from './ServiceProviderEmergencyCardAppResource';

import ConnectorImportAppResource from "./ConnectorImportAppResource";
import ConnectorAppResource from "./ConnectorAppResource";
import ConnectorConfigAppResource from "./ConnectorConfigAppResource";

//Integrations
import ExternalOfficeAppResource from "./ExternalOfficeAppResource";
import LuPointOfOriginAppResource from "./LuPointOfOriginAppResource";
import C21OrganizationAppResource from "./C21OrganizationAppResource";
import LuC21LocationIdAppResource from "./LuC21LocationIdAppResource";
import ConnectorImportLogAppResource from "./ConnectorImportLogAppResource";
import ExternalLoanAppResource from "./ExternalLoanAppResource";
import HubExternalLoanAppResource from "./HubExternalLoanAppResource";
import PropertyAttomHiddenMortgageAppResource from "./PropertyAttomHiddenMortgageAppResource";
import ProOnboardingStepAppResource from "./ProOnboardingStepAppResource";
import UserProOnboardingStepAppResource from "./UserProOnboardingStepAppResource";
import OrganizationSendgridSenderAppResource from "./OrganizationSendgridSenderAppResource";
import WorkspaceOrganizationMemberPlunkRemodelValueFavoriteAppResource
    from "./WorkspaceOrganizationMemberPlunkRemodelValueFavoriteAppResource";
import UserReferProLinkAppResource from './UserReferProLinkAppResource';
import HubImportTokenAppResource from './HubImportTokenAppResource';
import LuHubSourceAppResource from './LuHubSourceAppResource';
import HubSourceAppResource from "./HubSourceAppResource";
import LuHubImportSourceAppResource from './LuHubImportSourceAppResource';
import LuCommunicationContextAppResource from "./LuCommunicationContextAppResource";
import OrganizationDisclaimerAppResource from './OrganizationDisclaimerAppResource';
import OrganizationMemberOrganizationSubscriptionPlanAppResource
    from './OrganizationMemberOrganizationSubscriptionPlanAppResource';
import OrganizationSubscriptionPlanAppResource from './OrganizationSubscriptionPlanAppResource';
import LuSubscriptionPlanFeatureAppResource from './LuSubscriptionPlanFeatureAppResource';
import LuSubscriptionPlanFeatureSubscriptionPlanAppResource
    from './LuSubscriptionPlanFeatureSubscriptionPlanAppResource';
import SubscriptionPlanAppResource from './SubscriptionPlanAppResource';
import UserSubscriptionTrialAppResource from './UserSubscriptionTrialAppResource';
import OrganizationBrandAppResource from './OrganizationBrandAppResource';
import OrganizationDivisionAppResource from './OrganizationDivisionAppResource';
import OrganizationOperationAppResource from './OrganizationOperationAppResource';
import OrganizationMemberReportAppResource from './OrganizationMemberReportAppResource';
import LuHubImportStatusAppResource
    from '@milestoneslabs/milestones-core-js/src/AppResources/LuHubImportStatusAppResource';
import OrganizationSettingAppResource from './OrganizationSettingAppResource';
import IndustryAppResource from "./IndustryAppResource";
import ApiNationConnectionAppResource from './ApiNationConnectionAppResource';
import LuSubscriptionPlanFeatureCategoryAppResource from "./LuSubscriptionPlanFeatureCategoryAppResource";
import UpgradeExperienceAppResource from './UpgradeExperienceAppResource';

export default [
    AddressAppResource,
    AgentContactAppResource,
    AgentContactNoteAppResource,
    LuAgentContactTypeAppResource,
    BusinessCategoryAppResource,
    BusinessLicenseAppResource,
    BusinessProfileAppResource,
    BusinessScheduleAppResource,
    BusinessTypeAppResource,
    CalendarAppResource,
    CalendarCategoryAppResource,
    CalendarEventAppResource,
    CalendarEventAttendeeAppResource,
    CalendarEventAttendeeReminderAppResource,
    CalendarEventCategoryAppResource,
    CalendarEventStatusAppResource,
    ChannelAppResource,
    ChannelMemberAppResource,
    ContactAppResource,
    EmailAppResource,
    FileAppResource,
    FolderAppResource,
    FileDownloadTokenAppResource,
    FileTagAppResource,
    IndustryAssociationAppResource,
    InquiryAppResource,
    InquiryPropertyStatusAppResource,
    InquiryPropertySubtypeAppResource,
    InquiryPropertyTypeAppResource,
    KnowledgeAssetAppResource,
    KnowledgeAssetCategoryAppResource,
    KnowledgeAssetArticleAppResource,
    KnowledgeAssetTagAppResource,
    KnowledgeAssetVideoAppResource,
    KnowledgeBaseAppResource,
    LanguageAppResource,
    LeadAppResource,
    LeadDispositionAppResource,
    LeadQualificationDispositionQuestionAppResource,
    LeadQualificationQuestionAppResource,
    LeadSourceAppResource,
    LeadTypeAppResource,
    LuCalendarEventAttendeeStatusAppResource,
    LuWorkspaceMembershipTypeAppResource,
    LuOrganizationReportingRoleAppResource,
    ProjectTypeRoleAppResource,
    MarketAppResource,
    MLSAppResource,
    OrganizationAppResource,
    OrganizationMemberAppResource,
    OrganizationRoleAppResource,
    OrganizationBrandingAppResource,
    OrganizationPlatformBabAppResource,
    OrganizationDisclaimerAppResource,
    PhoneAppResource,
    PropertyAppResource,
    PropertyInstanceAppResource,
    RoleAppResource,
    ServiceTicketAppResource,
    StageAppResource,
    StageRoleAppResource,
    StageTypeAppResource,
    StageWorkspaceMemberAppResource,
    TaskAppResource,
    TaskAssigneeAppResource,
    TaskAssigneeReminderAppResource,
    TaskCategoryAppResource,
    TaskPriorityAppResource,
    TaskRoleAppResource,
    TaskStatusAppResource,
    UserAppResource,
    UserInvitationAppResource,
    WildAppResource,
    WorkspaceAppResource,
    WorkspaceOrganizationMemberAppResource,
    WorkspaceStageTypeAppResource,
    WorkspaceTypeAppResource,
    WorkspaceRoleAppResource,
    WorkspaceTypeAppResource,
    MessageAppResource,
    MessageChannelMemberReadAppResource,
    MessageMentionAppResource,
    TaskReminderAppResource,
    CalendarEventReminderAppResource,
    PlaybookAppResource,
    LuOrganizationOccupationAppResource,
    ResourceAppResource,
    ResourceType1AppResource,
    ResourceType2AppResource,
    ResourceType3AppResource,
    ResourceStageTypeAppResource,
    ResourceWorkspaceTypeAppResource,
    TaskListAppResource,
    TimelineAppResource,
    PublicOrganizationAppResource,
    LuDeclineInvitationReasonAppResource,
    BillboardAppResource,
    ProjectBillboardAppResource,
    QuestionAppResource,
    OptionAppResource,
    AnswerAppResource,
    LuHubSourceAppResource,
    HubSourceAppResource,

    //OAuth App Resources
    AuthCodeAppResource,
    ClientAppResource,
    PersonalAccessClientAppResource,
    RefreshTokenAppResource,
    TokenAppResource,

    LuProcessInputTypeAppResource,
    LuProcessOutputTypeAppResource,
    LuProcessTypeAppResource,
    ProcessAppResource,
    ProcessInputAppResource,
    ProcessInputCategoryAppResource,
    ProcessInstanceAppResource,
    ProcessInstanceInputAppResource,
    ProcessOutputAppResource,

    CityAppResource,
    MlsMarketAppResource,
    CityMlsMarketAppResource,
    PropertySearchFilterAppResource,
    ZipInfoAppResource,
    ReferralPartnerTypeAppResource,
    BusinessProfileServiceAppResource,
    ReferralPartnerAppResource,
    UserProfileAppResource,
    RecommendedBusinessAppResource,
    ActivityAppResource,
    PushSubscriptionAppResource,
    ActivityHistorySavedViewAppResource,

    FormAppResource,
    FormAuthorAppResource,
    FormsetAppResource,
    FormsetStartPageAppResource,
    FormsetSuccessPageAppResource,
    FormsetAdvertisementAppResource,
    LuCountryAppResource,
    LuStateAppResource,
    LuESignatureMethodAppResource,
    LuFormAuthorTypeAppResource,
    LuFormCategoryAppResource,
    LuFormLicenceStatusAppResource,
    LandingPageAppResource,
    LandingPageEmailBlastAppResource,
    LandingPageBuySectionAppResource,
    LandingPageFinanceSectionAppResource,
    LandingPageHomeSectionAppResource,
    LandingPageLearnSectionAppResource,
    LandingPageHomeLoanOfficerAppResource,
    LandingPageLinkAppResource,
    LandingPagePhoneAppResource,
    LandingPageSocialLinkAppResource,
    LandingPageSellSectionAppResource,
    LandingPageTradeSectionAppResource,
    LandingPageTypeSectionTypeAppResource,
    LandingPageSettingsAppResource,
    LandingPageActionAppResource,
    LandingPageHomeBabyOrAdoptionAppResource,
    LandingPageHomeTopicOfInterestAppResource,
    LandingPageViewAppResource,
    LuLandingPageSectionTypeAppResource,
    LuLandingPageTypeAppResource,
    LuLandingPageCategoryAppResource,
    LuLandingPageGalleryTypeAppResource,
    LandingPageGalleryImageAppResource,
    LandingPageEventAppResource,
    LandingPageHubPreviewAppResource,
    LuNotificationTypeAppResource,
    UserNotificationAppResource,

    SearchAlertSubscriberAppResource,

    //Kloudless
    KloudlessAccountAppResource,
    KloudlessServiceAppResource,
    KloudlessAccountCalendarPermissionAppResource,

    LuWorkspacePipelineStatusAppResource,
    ProfessionalLicenseAppResource,
    MlsMembershipAppResource,

    JotFormResourceSessionAppResource,
    JotFormResourceAnswerAppResource,
    ProjectMemberResourceAppResource,

    //Service Providers
    ServiceProviderAppResource,
    ServiceProviderIndustryAppResource,
    ServiceProviderTypeAppResource,
    ServiceProviderProjectTypeAppResource,
    ServiceProviderContactAppResource,
    ServiceProviderCallToActionAppResource,
    ServiceProviderFavoriteAppResource,
    ServiceProviderUserProfessionalAppResource,
    ServiceProviderLocationAppResource,
    ServiceProviderMessageAppResource,
    ServiceProviderRecommendationAppResource,
    ServiceProviderRecommendationTypeAppResource,
    ServiceProviderOrganizationListSettingAppResource,
    ServiceProviderContactLicenseTypeAppResource,
    ServiceProviderJotformRequestAppResource,
    ServiceProviderReferralTypeAppResource,
    ServiceProviderReferralLogAppResource,
    ServiceProviderCallToActionTypeAppResource,
    ServiceProviderImportAppResource,
    ServiceProviderEmergencyCardAppResource,

    PropertyValuationAppResource,
    PropertyMortgageAppResource,
    PropertyContactAppResource,
    PropertyContactNoteAppResource,
    LuPropertyContactTypeAppResource,
    HomeownersInsuranceAppResource,
    HomeValuationRequestAppResource,
    MortgageRateAppResource,
    LuListingStatusAppResource,
    HomeJunctionListingStatusAppResource,
    LuHomeTypeAppResource,
    HomeJunctionHomeTypeAppResource,
    WorkspaceLifeEventAppResource,

    //First American
    AssessorRecordAppResource,
    FirstAmericanLogAppResource,
    LuFinTypeAppResource,
    LuFipsAppResource,
    LuLoanTypeAppResource,
    ModelRecordAppResouce,

    DocumentTagAppResource,

    TaskRecurrenceAppResource,
    UserAccountConfirmationAppResource,

    //Moxi
    OrganizationMoxiCompanyAppResource,
    OrganizationMoxiOfficeAppResource,

    //Email Campaigns
    EmailCampaignAppResource,
    EmailCampaignMessageAppResource,
    EmailCampaignMessageSentAppResource,
    EmailCampaignUserAppResource,

    //Listings & Transactions
    TransactionAppResource,
    TransactionWorkspaceAppResource,
    LuIntegrationTypeAppResource,
    LuTransactionTypeAppResource,
    LuTransactionStatusAppResource,
    IntegrationStageTransactionStatusAppResource,
    HubExternalListingAppResource,
    HubExternalLoanAppResource,
    TransactionImportFilterAppResource,
    ExternalListingAppResource,
    OrganizationIntegrationAppResource,
    IntegrationListingStatusAppResource,
    LuListingStatusAppResource,

    WorkspaceMemberNotificationAppResource,

    NylasAccountAppResource,

    MortgageBalanceAppResource,

    //atom
    S3RecorderImportAppResource,
    S3AvmImportAppResource,
    LoanOfficerActionProgressAppResource,
    MoveHubAppResource,

    ConnectorImportAppResource,

    //Integrations
    ExternalOfficeAppResource,
    ExternalUserAppResource,
    ExternalLoanAppResource,
    ConnectorAppResource,
    ConnectorConfigAppResource,
    ConnectorImportLogAppResource,

    WorkspacePropertyValuationAppResource,
    GlobalUnsubscribeEmailAppResource,
    UnsubscribedEmailUserAppResource,
    UnsubscribeEmailAppResource,
    OrganizationAgentImportAppResource,
    OrganizationAgentImportLogAppResource,

    //Point of Origin
    LuPointOfOriginAppResource,

    C21OrganizationAppResource,
    LuC21LocationIdAppResource,

    PendingHubDetailsAppResource,
    HubInvitationSettingsAppResource,

    //SendGridMetrics
    SendGridMetricsAppResource,
    UserInvitationEventAppResource,

    OrganizationSendgridTemplateAppResource,
    MilestonesSendgridTemplateAppResource,

    PropertyAttomHiddenMortgageAppResource,
    ProOnboardingStepAppResource,
    UserProOnboardingStepAppResource,
    PartnerMlsMappingAppResource,
    OrganizationSendgridSenderAppResource,
    WorkspaceOrganizationMemberPlunkRemodelValueFavoriteAppResource,
    UserReferProLinkAppResource,
    ReferProLinkAppResource,

    //HubImport
    OrganizationHubImportAppResource,
    HubImportTokenAppResource,
    LuHubImportSourceAppResource,
    LuCommunicationContextAppResource,


    //Subscription
    OrganizationMemberOrganizationSubscriptionPlanAppResource,
    OrganizationSubscriptionPlanAppResource,
    UserSubscriptionTrialAppResource,
    LuSubscriptionPlanFeatureAppResource,
    LuSubscriptionPlanFeatureCategoryAppResource,
    LuSubscriptionPlanFeatureSubscriptionPlanAppResource,
    SubscriptionPlanAppResource,

    IndustryAppResource,

    OrganizationBrandAppResource,
    OrganizationDivisionAppResource,
    OrganizationOperationAppResource,
    OrganizationMemberReportAppResource,
    LuHubImportStatusAppResource,

    OrganizationSettingAppResource,
    ApiNationConnectionAppResource,

    ServiceAreaAppResource,

    UpgradeExperienceAppResource,
];
